export const CSV_UPLOADED = "upload.csvUploaded";
export const FILE_UPLOADED = "upload.fileUploaded";
